(function (angular) {
	'use strict';

	angular
		.module('investmentGoalModule', [
			'amountSelectModule',
			'coreModule',
			'confirmationModalModule',
			'investmentGoalChartModule',
			'minInvestmentAmountModule'
		])
		.constant('ACCOUNT_VALUE_AMOUNTS', [
			{
				value: 50000,
				label: '$50,000'
			}, {
				value: 100000,
				label: '$100,000'
			}, {
				value: 200000,
				label: '$200,000'
			}, {
				value: 250000,
				label: '$250,000'
			}, {
				value: 500000,
				label: '$500,000'
			}, {
				value: 0,
				label: 'Other Amount'
			}
		])

		.constant('INVESTMENT_GOAL_TIME_HORIZON_OPTIONS', [
			{ value: '60', label: '5 years' },
			{ value: '120', label: '10 years' },
			{ value: '180', label: '15 years' },
			{ value: '240', label: '20 years' }
		])
		.constant('INVESTMENT_GOAL_AUTO_INVEST_FREQUENCY_OPTIONS', [
			{
				value: 'MONTHLY',
				label: 'Monthly'
			}, {
				value: 'SEMI_MONTHLY',
				label: 'Twice a month'
			}
		])
		.constant('ROUNDING_VALUES', {
			totalAccountValue: 5000
		})
		.constant('MIN_INVESTMENT_AMOUNT', 100)
		.value('globalConfig', globalConfig);
})(window.angular);